import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { EVENT_CLOSE } from '_utils/constant'
import { convertToCurrentGMT, getDateRemainFromNow } from '_utils/function'
import useShareLinkEvent from '_hooks/useShareLinkEvent'

const now = moment().unix()
const MyEventItem = ({ event, openModal, setShareLink, isByAdmin = false }) => {
  const { handleShare, isLoading: isLoadingShare } = useShareLinkEvent()

  const [greyOut, setGreyOut] = useState(false)

  const history = useHistory()

  const onShare = () => {
    handleShare(event.id, (url) => {
      setShareLink(url)
      openModal()
    })
  }

  const handleRehostEvent = () => {
    if (!event.id) return
    history.push(`/event/hosting?id=${event.id}&fromReHost=1`)
  }
  const handleEditEvent = () => {
    if (!event.id) return
    history.push(`/event/hosting?id=${event.id}`)
  }
  useEffect(() => {
    setGreyOut(false)
    if (event?.pickupTimestamp < now || event?.status === EVENT_CLOSE) {
      setGreyOut(true)
    }
  }, [event?.status, event?.pickupTimestamp])

  const onLinkToListOrder = () => {
    if (isByAdmin) {
      history.push(`/event/manage-orders?eventId=${event.id}&isByAdmin=true`)
    } else {
      history.push(`/event/manage-orders?eventId=${event.id}`)
    }
  }

  const disabledStyleActions = {
    background: 'rgb(241, 241, 241)',
    pointerEvents: 'none',
  }

  const colorGray = {
    color: 'gray',
  }

  return (
    <div
      className='event-item group-list--event group-list--event01'
      style={greyOut ? { backgroundColor: '#dee2e6' } : {}}
    >
      <div className='group-list__item' style={greyOut ? { backgroundColor: '#dee2e6' } : {}}>
        <div className='group-list__info'>
          <h4
            onClick={onLinkToListOrder}
            className='cursor-pointer'
            style={greyOut ? colorGray : {}}
          >
            {event.title}
          </h4>

          <p className='paragraph-pre-wrap fw-semibold' style={greyOut ? colorGray : {}}>
            {event.description}
          </p>
          <p className='paragraph-pre-wrap' style={greyOut ? colorGray : {}}>
            Created: {moment.unix(event.createdAt).format('DD/MM/YYYY')}
          </p>
        </div>
        <div className='group-list__btn text-right'>
          {greyOut ? (
            <>
              <span className='txt-date mb-1' style={colorGray}>
                Closed: {moment(convertToCurrentGMT(event?.closingTime), 'DD-MM-YYYY HH:mm').format('DD/MM/YYYY')}
              </span>
              <span className='txt-date mb-2' style={colorGray}>
                Delivered: {moment(convertToCurrentGMT(event?.pickupTime), 'DD-MM-YYYY HH:mm').format('DD/MM/YYYY')}
              </span>
            </>
          ) : (
            <>
              <span className='txt-date mb-1'>
                {`closing in ${getDateRemainFromNow(convertToCurrentGMT(event?.closingTime))}`}
              </span>
              <span className='txt-date mb-2'>
                {`Delivery in ${getDateRemainFromNow(convertToCurrentGMT(event?.pickupTime))}`}
              </span>
            </>
          )}
          <span className='txt-number' style={greyOut ? { backgroundColor: 'gray' } : {}}>
            {event.totalOrderCount} BUY
          </span>
        </div>
      </div>
      <ul className='nav-tab'>
        <li style={isByAdmin ? disabledStyleActions : {}} onClick={handleEditEvent}>
          Edit Post
        </li>
        <li style={isByAdmin ? disabledStyleActions : {}} onClick={handleRehostEvent}>
          Re-host
        </li>
        <li
          style={isByAdmin || isLoadingShare ? disabledStyleActions : {}}
          onClick={onShare}
        >
          {isLoadingShare ? 'Loading...' : 'Share'}
        </li>
      </ul>
    </div>
  )
}

MyEventItem.propTypes = {
  event: PropTypes.object,
  openModal: PropTypes.func,
  setShareLink: PropTypes.func,
}

export default MyEventItem
